import { render, staticRenderFns } from "./NewDiscussion.vue?vue&type=template&id=14ca2df6&scoped=true"
import script from "./NewDiscussion.vue?vue&type=script&lang=js"
export * from "./NewDiscussion.vue?vue&type=script&lang=js"
import style0 from "./NewDiscussion.vue?vue&type=style&index=0&id=14ca2df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca2df6",
  null
  
)

export default component.exports